import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAdmin } from '../contexts/AdminContext';
import styles from '../styles/Header.module.css';
// Import the logo image
import logo from '../images/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showAnnouncement, setShowAnnouncement] = useState(true);
  const [timeRemaining, setTimeRemaining] = useState({
    hours: 0,
    minutes: 24,
    seconds: 0
  });
  const { currentUser, logout } = useAuth();
  const { isAdmin } = useAdmin();
  const navigate = useNavigate();

  // Set up countdown timer
  useEffect(() => {
    // Check if we already have an end time in localStorage
    const storedEndTime = localStorage.getItem('offerEndTime');
    let endTime;
    
    if (storedEndTime) {
      // Use the stored end time
      endTime = parseInt(storedEndTime, 10);
    } else {
      // Create a new end time: current time + 24 minutes
      endTime = Date.now() + 24 * 60 * 1000;
      localStorage.setItem('offerEndTime', endTime.toString());
    }

    // Update countdown every second
    const timer = setInterval(() => {
      const now = Date.now();
      const difference = endTime - now;
      
      // If countdown is finished
      if (difference <= 0) {
        // Reset timer to a new 24-minute period
        endTime = Date.now() + 24 * 60 * 1000;
        localStorage.setItem('offerEndTime', endTime.toString());
        
        // Reset the countdown display
        setTimeRemaining({ hours: 0, minutes: 24, seconds: 0 });
        
        // Don't hide the banner
        // clearInterval(timer);
        // setShowAnnouncement(false);
        // return;
      }
      
      // Calculate remaining time
      const hours = Math.floor(difference / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      
      setTimeRemaining({ hours, minutes, seconds });
    }, 1000);
    
    // Cleanup timer on component unmount
    return () => clearInterval(timer);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
      setIsMenuOpen(false);
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const closeAnnouncement = () => {
    setShowAnnouncement(false);
  };

  // Format time display
  const formatTime = (value) => {
    return value < 10 ? `0${value}` : value;
  };

  return (
    <>
      {/* Closable Announcement Bar with Countdown */}
      {showAnnouncement && (
        <div className={styles.announcementBar}>
          <div className={styles.announcementContent}>
            <span className={styles.promoBadge}>LIMITED TIME</span>
            <span className={styles.announcementText}>
              Get a Second Version of Your Song Free
            </span>
            <span className={styles.countdownTimer}>
              {formatTime(timeRemaining.hours)}:{formatTime(timeRemaining.minutes)}:{formatTime(timeRemaining.seconds)} remaining
            </span>
            <button 
              className={styles.closeButton} 
              onClick={closeAnnouncement}
              aria-label="Close announcement"
            >
              &times;
            </button>
          </div>
        </div>
      )}
      
      <header className={styles.header}>
        <div className={styles.container}>
          {/* Logo on the left */}
          <Link to="/" className={styles.logo}>
            <img 
              src={logo} 
              alt="MakeMeSongs" 
              className={styles.logoImage} 
            />
          </Link>
          
          {/* Hamburger Menu Button */}
          <button 
            className={`${styles.hamburgerMenu} ${isMenuOpen ? styles.open : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Authentication buttons and nav links */}
          <div className={`${styles.headerRight} ${isMenuOpen ? styles.mobileMenuOpen : ''}`}>
            {currentUser ? (
              /* Show navigation links and user menu for logged-in users */
              <>
                <nav className={styles.navLinks}>
                  <Link to="/" className={styles.navLink} onClick={closeMenu}>Home</Link>
                  <Link to="/packages" className={styles.navLink} onClick={closeMenu}>Packages</Link>
                  <Link to="/dashboard" className={styles.navLink} onClick={closeMenu}>Dashboard</Link>
                  {isAdmin && (
                    <Link to="/admin" className={styles.navLink} onClick={closeMenu}>Admin</Link>
                  )}
                </nav>
                <div className={styles.userMenu}>
                  <span className={styles.greeting}>Hello, {currentUser.email.split('@')[0]}</span>
                  <button onClick={handleLogout} className={styles.logoutButton}>Log Out</button>
                </div>
              </>
            ) : (
              /* Show only auth buttons for non-logged in users */
              <div className={styles.authButtons}>
                <Link to="/login" className={styles.loginButton} onClick={closeMenu}>Login</Link>
                <Link to="/packages" className={styles.getStartedButton} onClick={closeMenu}>Get Started</Link>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;